<script setup lang="ts">
</script>

<template>
  <div class="self">
    <sidebar-self-avatar />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.self
  @apply p-3 justify-end flex items-center z-navigation-layer

.roots
  @apply mt-[#{$sidebar-m-header-top}] p-[#{$sidebar-p-main}] flex flex-col gap-[#{$sidebar-gap-items-container}]
</style>
